// extracted by mini-css-extract-plugin
module.exports = {"groupingsList":"groupings-list_groupingsList__-RxXb","groups":"groupings-list_groups__3_n50","fab":"groupings-list_fab__2DXaN"};